import { Component, ViewChild, OnInit, OnDestroy } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { ApiService } from 'src/app/api.service';
declare var require: any;
import { NotifierService } from 'angular-notifier';
import { formatDate, DatePipe } from '@angular/common';
import { MatMenuTrigger } from '@angular/material/menu';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { EnvService } from 'src/app/service/system/env-service';

@Component({
  selector: 'app-usertable',
  templateUrl: './usertable.component.html',
  styleUrls: ['./usertable.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class UsertableComponent implements OnInit, OnDestroy {
  converstation = [];
  intentSkills = [];
  channel;
  language;
  ConversationTable: any =
    {
      dataSource: [],
      pagination:
      {
        pageNo: 1,
        limit: 10,
        totalCount: 100,
        token: null,
        hasNext: false,
        pageSizeOptions: [10, 20],
      },
      columnsToDisplay: ['Sno', 'userId', 'timestamp', 'conversation',  'reviewStatus'], //'rating','feedBack',
      searchText: "",
      searchType: "all",
      sortByCol: "user_id",
      sortByType: "DESC",
      pagedData: [],
      lenght: 1,
    };

  timeRange = {
    selectionType: '',
    displayNameOfSelected: "",
    displayNameOfSelectionInProgress: "",
    selectedDates: {
      from: null,
      to: null
    },
    maxDate: new Date(),
    nDays: 0,
    selectionKey: null
  };

  @ViewChild('menuDatesFilterTrigger') datesFilterTrigger: MatMenuTrigger;

  expandedElement: null;
  lastSyncedTime: any = "Not yet";
  panelOpenState = false;
  startDate: Date = new Date();
  endDate: Date = new Date();
  maxDate: Date = new Date();
  maxEndDate: Date = new Date();
  showHideExportDiv: Boolean = false;
  private readonly notifier: NotifierService;
  private _channelSubscription: Subscription;
  private _languageSubscription: Subscription;

  // Images
  searchImagePath: string = require('../../assets/images/ic_search.svg');
  clearImagePath: string = require('../../assets/images/clear.png');
  ratingImagePath1: string = require('../../assets/images/very sad.svg');
  ratingImagePath2: string = require('../../assets/images/sad.svg');
  ratingImagePath3: string = require('../../assets/images/avg.svg');
  ratingImagePath4: string = require('../../assets/images/happy.svg');
  ratingImagePath5: string = require('../../assets/images/very happy.svg');

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private service: ApiService, notifierService: NotifierService, private env: EnvService, private datePipe: DatePipe) {
    this.notifier = notifierService;

    let pageFilters = this.getPersistedPageFilters();
    if (pageFilters != null) {
      this._setPredefinedDate(pageFilters);
    }
    else {
      this._setDateFilterToToday();
    }

    this._channelSubscription = this.service.onChannelChanged.subscribe(channel => {
      this.channel = channel.value;
      this.resetUserTable(1, this.ConversationTable.pagination.limit);
      this.GetConversationList();
    });

    this._languageSubscription = this.service.onLanguageChanged.subscribe(lang => {
      this.language = lang.value;
      this.resetUserTable(1, this.ConversationTable.pagination.limit);
      this.GetConversationList();
    });

    this.GetIntentList();
    this.maxEndDate.setDate(this.maxEndDate.getDate() + 7);
  }

  ngOnInit() {
    this.ConversationTable.dataSource.paginator = this.paginator;
  }

  ngOnDestroy(): void {
    this._channelSubscription.unsubscribe();
    this._languageSubscription.unsubscribe();
  }

  GetConversationList() {
    if (this.channel && this.language) {
      document.getElementById("loaderSpinner").style.display = 'block';
      if (this.getPagedData(this.ConversationTable.pagination.pageNo)) {
        let response = this.getPagedData(this.ConversationTable.pagination.pageNo);
        this.ConversationTable.dataSource = response.results;
        this.ConversationTable.token = response.token;
        document.getElementById("loaderSpinner").style.display = 'none';
      } else {
        return this.service.getConversationList(
          this.timeRange.selectedDates.from,
          this.timeRange.selectedDates.to,
          this.language,
          this.channel,
          this.ConversationTable.pagination.pageNo,
          this.ConversationTable.pagination.limit,
          this.ConversationTable.searchText,
          this.ConversationTable.searchType,
          this.ConversationTable.sortByCol,
          this.ConversationTable.sortByType, this.ConversationTable.pagination.token).subscribe((data: {}) => {
            document.getElementById("loaderSpinner").style.display = 'none';
            if (data["status"] == 200) {
              this.ConversationTable.dataSource = data["data"];
              // this.ConversationTable.pagination.totalCount = data["totalCount"];
              // this.lastSyncedTime = data["lastSyncedTime"];
              this.setPagedDate(this.ConversationTable.pagination.pageNo, data["token"], data["data"]);
              if (data["has_next"]) {
                this.ConversationTable.lenght = this.ConversationTable.lenght + this.ConversationTable.pagination.limit;
                this.ConversationTable.pagination.token = data["token"];
              }
            } else {
              this.notifier.notify("error", data["status_details"]);
            }
          })
      }

    }
  }

  GetConversationListForce() {
    this.resetUserTable(1, this.ConversationTable.pagination.limit);
    this.GetConversationList();
  }

  onStartDateChanged(event) {
    this.maxEndDate.setDate(this.startDate.getDate());
    this.maxEndDate.setMonth(this.startDate.getMonth());
    this.maxEndDate.setFullYear(this.startDate.getFullYear());
    this.maxEndDate.setDate(this.maxEndDate.getDate() + 7);
    this.endDate = this.maxEndDate;
  }

  private setPagedDate(pageNumber, token, users) {
    if (!this.ConversationTable.pagedData.find(item => item.page == pageNumber)) {
      this.ConversationTable.pagedData.push({ page: pageNumber, token: token, results: users })
    }
  }

  private getPagedData(pageNumber) {
    return this.ConversationTable.pagedData.find(item => item.page == pageNumber);
  }


  showHideExport() {
    this.showHideExportDiv = !this.showHideExportDiv;
  }

  GetIntentList() {
    return this.service.getIntentList().subscribe((data: {}) => {
      if (data["status"] == 200) {
        this.intentSkills = data["data"];
      } else {
        this.notifier.notify("error", data["status_details"]);
      }
    })
  }

  public getPaginatorData(event: PageEvent) {
    if (event.pageSize != this.ConversationTable.pagination.limit) {
      this.resetUserTable(1, event.pageSize);
    } else {
      this.ConversationTable.pagination.pageNo = event.pageIndex + 1;
      this.ConversationTable.pagination.limit = event.pageSize;
    }
    this.GetConversationList();
  }

  resetUserTable(page, length) {
    if(this.paginator){
      this.paginator.firstPage();
    }
    this.ConversationTable.dataSource.paginator = this.paginator;
    this.ConversationTable.pagination.pageNo = page;
    this.ConversationTable.pagination.limit = length;
    this.ConversationTable.lenght = length;
    this.ConversationTable.pagedData = [];
    this.ConversationTable.pagination.token = null
  }

  searchId = null;
  isLoading = false;
  onClickConverstations(id: any) {
    if(this.searchId == null || this.searchId != id) {
      this.isLoading = true;
      this.converstation = [];
      this.searchId = id;
      return this.service.getFullConversationList(id).subscribe((data: {}) => {
        if (data["status"] == 200) {
          this.converstation = data["data"];
        } else {
          this.notifier.notify("error", data["status_details"]);
        }
        this.isLoading = false;
      })
    }
  }

  changeSearchText(eveny: any) {
    this.ConversationTable.searchText = event['target']['value'];
    this.resetUserTable(1, this.ConversationTable.pagination.limit);
    this.GetConversationList();
  }

  ClearSearchText() {
    this.ConversationTable.searchText = "";
    this.resetUserTable(1, this.ConversationTable.pagination.limit);
    this.GetConversationList()
  }

  toTimestamp(strDate) {
    var datum = Date.parse(strDate);
    return datum / 1000;
  }

  downloadReport() {
    this.service.downloadConversationFile(this.datePipe.transform(this.startDate, "yyyy-MM-dd"), this.datePipe.transform(this.endDate, "yyyy-MM-dd"), this.channel, this.language);
    // var link = document.createElement("a");
    // link.download = "Report.csv";
    // link.href = this.env.baseUrl + `conversations/export?from=${this.datePipe.transform(this.startDate, "yyyy-MM-dd")}&to=${this.datePipe.transform(this.endDate, "yyyy-MM-dd")}&ChannelName=${this.channel}&language=${this.language}`;
    // this.startDate = new Date();
    // this.endDate = new Date();
    // link.click();
    this.showHideExportDiv = !this.showHideExportDiv;
  }

  syncCosmosData() {
    document.getElementById("loaderSpinner").style.display = 'block';
    return this.service.syncCosmosData().subscribe((data: {}) => {
      document.getElementById("loaderSpinner").style.display = 'none';
      if (data["status"] == 200) {
        this.notifier.notify("success", "Synced " + data["data"] + " item(s) succesfully.");
        this.GetConversationList();
      } else {
        this.notifier.notify("error", data["status_details"]);
      }
    })
  }

  onChangeSearchOption(event: any) {
    this.ConversationTable.searchType = event;
    this.resetUserTable(1, this.ConversationTable.pagination.limit);
    this.GetConversationList();
  }

  sortData(event: any) {
    // this.ConversationTable.sortByCol = event;
    // this.ConversationTable.sortByType = this.ConversationTable.sortByType == "DESC" ? "ASC" : "DESC";
    // this.resetUserTable(1, this.ConversationTable.pagination.limit);
    // this.GetConversationList();
  }



  _setDateFilterToToday() {
    this.timeRange.selectionType = "predefinedDate";
    this.timeRange.selectedDates.to = new Date();
    this.timeRange.selectedDates.from = this.getAfterSettingTimeToZero(this.timeRange.selectedDates.to);
    this.timeRange.displayNameOfSelected = "Today";
    this.timeRange.displayNameOfSelectionInProgress = "Today";
    this.timeRange.selectionKey = this.timeRange.selectedDates.from.getTime();
    this.onDateFilterSubmit();
  }

  _setDateFilterToYesterday() {
    this.timeRange.selectionType = "predefinedDate";
    this.timeRange.selectedDates.to = this.getAfterSettingTimeToMax(this.getDateSubstractingDaysToTheGiven(new Date(), 1));
    this.timeRange.selectedDates.from = this.getAfterSettingTimeToZero(this.timeRange.selectedDates.to);
    this.timeRange.displayNameOfSelected = "Yesterday";
    this.timeRange.displayNameOfSelectionInProgress = "Yesterday";
    this.timeRange.selectionKey = this.timeRange.selectedDates.from.getTime() + this.timeRange.selectedDates.to.getTime();
    this.onDateFilterSubmit();
  }

  _setDateFilterToLastNDays(n) {
    this.timeRange.selectionType = "predefinedDate";
    this.timeRange.selectedDates.to = this.getAfterSettingTimeToMax(new Date());
    this.timeRange.selectedDates.from = this.getAfterSettingTimeToZero(this.getDateSubstractingDaysToTheGiven(this.timeRange.selectedDates.to, n - 1));
    this.timeRange.displayNameOfSelected = `Last ${n} Days`;
    this.timeRange.displayNameOfSelectionInProgress = `Last ${n} Days`;
    this.timeRange.nDays = n;
    this.timeRange.selectionKey = this.timeRange.selectedDates.from.getTime() + this.timeRange.selectedDates.to.getTime();
    this.onDateFilterSubmit();
  }

  _setPredefinedDate(timeRange: any) {
    if (timeRange.displayNameOfSelected == "Today") {
      this._setDateFilterToToday();
    }
    else if (timeRange.displayNameOfSelected == "Yesterday") {
      this._setDateFilterToYesterday();
    }
    else if (timeRange.displayNameOfSelected.startsWith("Last")) {
      this._setDateFilterToLastNDays(timeRange.nDays);
    }
    else {
      this.timeRange = timeRange;
    }
  }

  getAfterSettingTimeToZero(date: Date) {
    var copyOfDate: Date = new Date(date.getTime());
    copyOfDate.setHours(0, 0, 0, 0);
    return copyOfDate;
  }

  getAfterSettingTimeToMax(date: Date) {
    var copyOfDate: Date = new Date(date.getTime());
    copyOfDate.setHours(23, 59, 59, 999);
    return copyOfDate;
  }

  getDateRangeDisplayString(): string {
    return this.getFormatedDateOrEmptyString(this.timeRange.selectedDates.from) + " - " + this.getFormatedDateOrEmptyString(this.timeRange.selectedDates.to)
  }

  getFilters() {
    return this.timeRange;
  }

  private getDateSubstractingDaysToTheGiven(givenDate: Date, daysToAdd: number): any {
    let copyOfGivenDate: Date = new Date(givenDate.getTime());
    return new Date(copyOfGivenDate.setDate(givenDate.getDate() - daysToAdd));
  }

  maxEndDateRange = new Date();
  onPageFilterDateFromSelect(event: Date) {
    var selectedDate = this.getAfterSettingTimeToZero(event);
    this.timeRange.selectedDates.from = selectedDate;
    this.timeRange.displayNameOfSelectionInProgress = this.getFormatedDateOrEmptyString(this.timeRange.selectedDates.from) + " - " + this.getFormatedDateOrEmptyString(this.timeRange.selectedDates.to);
    this.maxEndDateRange.setDate(this.timeRange.selectedDates.from.getDate());
    this.maxEndDateRange.setMonth(this.timeRange.selectedDates.from.getMonth());
    this.maxEndDateRange.setFullYear(this.timeRange.selectedDates.from.getFullYear());
    this.maxEndDateRange.setDate(this.timeRange.selectedDates.from.getDate() + 30);
    if(this.maxEndDateRange > new Date()){
      this.maxEndDateRange = new Date();
    }
    this.onPageFilterDateToSelect(this.maxEndDateRange);
  }

  onPageFilterDateToSelect(event) {
    var selectedDate = this.getAfterSettingTimeToMax(event);
    this.timeRange.selectedDates.to = selectedDate;
    this.timeRange.displayNameOfSelectionInProgress = this.getFormatedDateOrEmptyString(this.timeRange.selectedDates.from) + " - " + this.getFormatedDateOrEmptyString(this.timeRange.selectedDates.to)
  }

  onDatesFilterClosed() {
    // Moved to submit
    // this.pageFilters.timeRange.displayNameOfSelected = this.pageFilters.timeRange.displayNameOfSelectionInProgress;
    // this.onFiltersChanged();
  }

  onDateFilterSubmit() {
    if (this.datesFilterTrigger) {
      this.datesFilterTrigger.closeMenu();
    }
    this.timeRange.displayNameOfSelected = this.timeRange.displayNameOfSelectionInProgress;
    this.timeRange.selectionKey = this.timeRange.selectedDates.from.getTime() + "-" + this.timeRange.selectedDates.to.getTime();
    this.onFiltersChanged();
  }

  private onFiltersChanged() {
    this.persistPageFilters();
    this.resetUserTable(1, this.ConversationTable.pagination.limit);
    this.GetConversationList()
  }

  private persistPageFilters() {
    localStorage.setItem('timeRange', JSON.stringify(this.timeRange));
  }

  private getFormatedDateOrEmptyString(date: Date) {
    if (date == null || '') {
      return '';
    }
    else {
      return formatDate(date, 'mediumDate', 'en-US')
    }
  }

  private getPersistedPageFilters() {
    let timeRange = JSON.parse(localStorage.getItem('timeRange'));
    if (timeRange) {
      timeRange.selectedDates.to = new Date(timeRange.selectedDates.to);
      timeRange.selectedDates.from = new Date(timeRange.selectedDates.from);
    }
    return timeRange;
  }

  onTranscriptFeedbackChange() {
    var el = this.ConversationTable.dataSource.find(c => c.conversation_id === this.searchId);
    if (el.review_data.review_status === 'Completed') {
      return;
    }
    el.review_data.review_status = 'Partially Completed';
  }

}
